import API from '../../../helpers/request/api';

const api = () => new API();

const fetchTags = (communityData) => {
  const { communityId } = communityData;

  const query = {
    variables: { communityId },
    query: `query community_all_tags($communityId: String!) {
      community_all_tags(
        community_id: $communityId,
      ) {
        id
        name
        description
      }
    }`,
  };

  return api().get(query);
};

const fetchPopularTags = (communityId, postFilter) => {
  const query = {
    query: `query popular_community_tags {
      popular_community_tags(
        community_id: ${communityId},
        search: "${postFilter.search}",
        moderation_state: "${postFilter.moderationState}"
      ) {
        id
        name
        posts
      }
    }`,
  };

  return api().get(query);
};

const fetchPopularCommunityBookmarkedTags = (communityId) => {
  const query = {
    query: `query popular_community_bookmarked_tags {
      popular_community_bookmarked_tags(
        community_id: "${communityId}",
      ) {
        id
        name
        posts
      }
    }`,
  };

  return api().get(query);
};

export default {
  fetchTags,
  fetchPopularTags,
  fetchPopularCommunityBookmarkedTags,
};



// WEBPACK FOOTER //
// ./src/screens/Community/queries/tag.js